import React, { useContext, useEffect, useState } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";
import { SquareArrowOutUpRight, TriangleAlert } from "lucide-react";
import axios from "axios";
import { base_url } from "../../config";

const workshopDates = [
  {
    date: "15",
    month: "Aug",
    day: "Sat",
    year: "2026",
    location: "Bremen",
    wsday: 1

  },
  {
    date: "16",
    month: "Aug",
    day: "Sun",
    year: "2026",
    location: "Bremen",
    wsday: 2
  },
  {
    date: "17",
    month: "Aug",
    day: "Mon",
    year: "2026",
    location: "Bremen",
    wsday: 3
  },
];



function ToggleSwitch({ enabled = false, changed }: { enabled?: boolean, changed?: (enabled: boolean) => void }) {
  const [switchEnabled, setswitchEnabled] = useState(enabled);

  return (
    <button
      onClick={() => {
        setswitchEnabled(!switchEnabled);
        if (changed) changed(!switchEnabled);
      }}
      className={`w-8 h-4 flex items-center rounded-full p-0.5 transition-colors duration-300 ${switchEnabled ? "bg-green-500" : "bg-gray-300"
        }`}
    >
      <div
        className={`bg-white w-3 h-3 rounded-full shadow-md transform transition-transform duration-300 ${switchEnabled ? "translate-x-4" : "translate-x-0"
          }`}
      />
    </button>
  );
}
function arraysEqual(a: number[], b: number[]) {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((val, idx) => val === sortedB[idx]);
}


export const WorkhshopSelection = () => {
  const { data, setData } = useContext(RegistrationContext);
  const wslist = data.workshops.map((workshop: any) => {
    const days = [];
    if (workshop.day1_morning || workshop.day1_afternoon) days.push(1);
    if (workshop.day2_morning || workshop.day2_afternoon) days.push(2);
    if (workshop.day3_morning || workshop.day3_afternoon) days.push(3);

    return {
      ...workshop
      , days: days
    }
  })

  const wsDates = workshopDates.map((date) => {
    var registered = false;
    if (data.workshop_day1 && date.wsday === 1) registered = true;
    if (data.workshop_day2 && date.wsday === 2) registered = true;
    if (data.workshop_day3 && date.wsday === 3) registered = true;
    return {
      ...date,
      registered
    };
  });
  const [selectedWorkshops, setSelectedWorkshops] = useState(data.selected_ws);
  const [selectionChanged, setSelectionChanged] = useState(false);
  const [preferencesSaved, setPreferencesSaved] = useState(false);
  const [incompleteWorkshops] = useState(false);
  const initialSelection = data.selected_ws;


  const handleSubmit = async () => {

    try {
      const ans = await axios.post(`${base_url}/api/workshop_update`, {
        selectedWorkshops
      });
      setData(ans.data.data);
      setPreferencesSaved(true);
    } catch (error) {

    }
  };

  useEffect(() => {
    setSelectionChanged(!arraysEqual(selectedWorkshops, initialSelection))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWorkshops])


  if (preferencesSaved) {
    return (
      <div className="rounded-lg border bg-white p-6 shadow-sm" >
        <h2 className="mb-4 text-xl font-bold">Workshop selection saved</h2>
        <p className="text-gray-700">
          Your workshop selection has been successfully saved.
        </p>

        <button
          className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          onClick={() => setPreferencesSaved(false)}
        >
          OK
        </button>
      </div>
    );
  }

  return (
    <div
      className=" rounded-lg border bg-white p-6 shadow-sm overflow-y-scroll"
      id="cancellation"

    >

      <h2 className="mb-4 text-xl font-bold">Workshops</h2>
      {incompleteWorkshops && (
        <p className="text-gray-700 mb-4 bg-red-100 p-4 rounded-xl flex">
          <TriangleAlert />
          <div className="pl-4">Your have workshops selected for days not included in your registration. Please contact registration@ijcai.org  </div>
        </p>)}
      {wsDates.map((workshop_date: any, index: any) => {
        var fontcolor = workshop_date.registered ? "text-black" : "text-gray-400 opacity-70"
        return (
          <div key={index} className="mb-4">
            <h3 className={`text-lg font-semibold ${fontcolor}`} >{workshop_date.date} {workshop_date.month} {workshop_date.day}, {workshop_date.year} - {workshop_date.location} {!workshop_date.registered && <span className="text-gray-600 text-sm"> — Not included in your registration</span>} </h3>

            {wslist
              .filter((workshop: any) => workshop.days.includes(workshop_date.wsday))
              .map((workshop: any, index: any) => {
                const selected = selectedWorkshops.includes(workshop.id);
                return (
                  <div key={index} className={`flex gap-3 text-xs ${fontcolor} my-1 hover:bg-gray-50`}>
                    <div className="font-mono">{
                      workshop.workshop_code}
                    </div>
                    <a href={workshop.url} target="_blank" rel="noreferrer"><SquareArrowOutUpRight size={12} /></a>
                    <div className="grow max-w-[800px]">
                      {workshop.title}
                    </div>
                    <div style={{ width: "100px" }} className="flex items-center justify-end">
                      {selected && !workshop_date.registered && (
                        <div className="relative group text-red-500 rounded-xl inline-block">
                          <TriangleAlert size={14} />

                        </div>
                      )}
                      {workshop_date.registered && (
                        <div className="relative group text-red-500 rounded-xl inline-block">
                          <ToggleSwitch enabled={selected} changed={(n) => {
                            if (n) {
                              setSelectedWorkshops([...selectedWorkshops, workshop.id]);
                            } else {
                              setSelectedWorkshops(selectedWorkshops.filter((id: Number) => id !== workshop.id));
                            }

                          }} />
                        </div>
                      )}
                    </div>

                  </div>)
              })
            }
          </div>
        );
      }
      )}
      <div className="pt-6">
        <button
          disabled={!selectionChanged}
          type="submit"
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-30"
          onClick={() => handleSubmit()}
        >
          Save New Workshop Selection
        </button>
      </div>
    </div>

  );
};
